/**
 * CL-ACCESS-FINANCIALS-001B — Fail-closed browser gate for Accounting permission UI.
 *
 * Compile-time default true (001F-S1). No environment, Auth-claim, or URL override.
 * Tests inject via the optional `accountingPermissionsUiEnabled` parameter on pure helpers.
 */

export const PROJECT_ACCOUNTING_PERMISSIONS_UI_ENABLED = true;

export function projectAccountingPermissionsUiEnabled(accountingPermissionsUiEnabled = null) {
  if (accountingPermissionsUiEnabled === true) return true;
  if (accountingPermissionsUiEnabled === false) return false;
  return PROJECT_ACCOUNTING_PERMISSIONS_UI_ENABLED === true;
}
